// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-base-preview{font-size:120px;text-align:center;height:100%;display:flex;justify-content:center;align-items:center}.cvat-base-preview .ant-spin{position:inherit}.cvat-base-preview svg{width:65%;height:65%}.cvat-base-preview .anticon{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.cvat-question-circle-filled-icon{font-size:112px;opacity:.5}", ""]);
// Exports
module.exports = exports;
